module.exports = __webpack_public_path__ + "static/media/caretDown.df1c35a9.svg";